// extracted by mini-css-extract-plugin
export default {"banner":"offline-banner_banner__YTx76","dot":"offline-banner_dot__XyLXS","pulse":"offline-banner_pulse__gxYXm"};